import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getUserNotificationsQuery,
  getUserNotificationsWithReadUnreadQuery,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import {
  listUserNotifications,
  listUserNotificationsAll,
  updateUserNotificationList,
} from "../slices/userNotificationSlice";
import {
  updateAllNotificationStatusMutation,
  updateNotificationStatusMutation,
} from "../../graphql/mutations";
import GrafanaClient from "../../config/grafanaClient";

export const getUserNotificationsThunk = createAsyncThunk(
  "get/notifications",
  async (_request: any, { dispatch }) => {
    try {
      const getUserNotifications = (await API.graphql(
        graphqlOperation(getUserNotificationsQuery, _request)
      )) as { data: any; errors: any[] };
      dispatch(
        listUserNotifications(getUserNotifications.data.getUserNotifications)
      );
    } catch (error) {}
  }
);

export const getUserNotificationsWithReadUnreadThunk = createAsyncThunk(
  "get/notificationswithreadunread",
  async (_request: any, { dispatch }) => {
    try {
      const getUserNotificationsWithReadUnread: any = await GrafanaClient().get(
        "/notification/get-notification-data",        
        {params:_request}        
      );      
      const notificationData = {
        notificationAPIRes:
        getUserNotificationsWithReadUnread.data.result,
        type: _request?.status,
      };

      // const getUserNotificationsWithReadUnread = (await API.graphql(
      //   graphqlOperation(getUserNotificationsWithReadUnreadQuery, _request)
      // )) as { data: any; errors: any[] };

      // console.log('getUserNotificationsWithReadUnread2222',getUserNotificationsWithReadUnread);

      // const notificationData = {
      //   notificationAPIRes:
      //     getUserNotificationsWithReadUnread.data
      //       .getUserNotificationsWithReadUnread,
      //   type: _request?.status,
      // };

      dispatch(listUserNotificationsAll(notificationData));
    } catch (error) {}
  }
);

export const updateNotificationStatusThunk = createAsyncThunk(
  "update/userNotification",
  async (_request: any, { dispatch }) => {
    try {
      const updateResponse = (await API.graphql(
        graphqlOperation(updateNotificationStatusMutation, {
          update: _request.update,
        })
      )) as { data: any; errors: any[] };

      const { notificationType } = _request;

      if (notificationType === "unread") {
        let index = _request?.notificationsUnRead?.notifications?.findIndex(
          (item: any) =>
            item.sk == _request?.update?.update[0]?.sk &&
            item.pk == _request?.update?.update[0]?.pk
        );

        if (index == 0 || index > 0) {
          const getAllNoti = _request?.notificationsUnRead?.notifications;
          const getNoti = {
            ...getAllNoti[index],
            is_read: _request?.update?.update[0]?.is_read,
          };

          const notificationsUnReadFilter =
            _request?.notificationsUnRead?.notifications?.filter(
              (l: any, i: any) => i != index
            );

          const notificationsUnRead = {
            ..._request?.notificationsUnRead,
            notifications: notificationsUnReadFilter,
          };

          const notificationsRead = {
            ..._request?.notificationsRead,
            notifications: [
              getNoti,
              ..._request?.notificationsRead?.notifications,
            ],
          };

          //Updating in All Notifications
          let AllIndex = _request?.notificationsAll?.notifications?.findIndex(
            (item: any) =>
              item.sk == _request?.update?.update[0]?.sk &&
              item.pk == _request?.update?.update[0]?.pk
          );

          let getAllNotiOfAll = _request?.notificationsAll?.notifications;
          if (AllIndex == 0 || AllIndex > 0) {
            getAllNotiOfAll = getAllNotiOfAll.map((l: any, idx: any) => {
              if (idx == AllIndex) {
                return {
                  ...l,
                  is_read: _request?.update?.update[0]?.is_read,
                };
              } else {
                return {
                  ...l,
                };
              }
            });
          }
          const notificationsAll = {
            ..._request?.notificationsAll,
            notifications: getAllNotiOfAll,
          };

          dispatch(
            updateUserNotificationList({
              ..._request,
              notificationsUnRead: notificationsUnRead,
              notificationsRead: notificationsRead,
              notificationsAll: notificationsAll,
            })
          );
        }
      }

      if (notificationType === "read") {
        let index = _request?.notificationsRead?.notifications?.findIndex(
          (item: any) =>
            item.sk == _request?.update?.update[0]?.sk &&
            item.pk == _request?.update?.update[0]?.pk
        );

        if (index == 0 || index > 0) {
          const getAllNoti = _request?.notificationsRead?.notifications;
          const getNoti = {
            ...getAllNoti[index],
            is_read: _request?.update?.update[0]?.is_read,
          };

          const notificationsReadFilter =
            _request?.notificationsRead?.notifications?.filter(
              (l: any, i: any) => i != index
            );

          const notificationsRead = {
            ..._request?.notificationsRead,
            notifications: notificationsReadFilter,
          };

          const notificationsUnRead = {
            ..._request?.notificationsUnRead,
            notifications: [
              getNoti,
              ..._request?.notificationsUnRead?.notifications,
            ],
          };

          //Updating in All Notifications
          let AllIndex = _request?.notificationsAll?.notifications?.findIndex(
            (item: any) =>
              item.sk == _request?.update?.update[0]?.sk &&
              item.pk == _request?.update?.update[0]?.pk
          );

          let getAllNotiOfAll = _request?.notificationsAll?.notifications;
          if (AllIndex == 0 || AllIndex > 0) {
            getAllNotiOfAll = getAllNotiOfAll.map((l: any, idx: any) => {
              if (idx == AllIndex) {
                return {
                  ...l,
                  is_read: _request?.update?.update[0]?.is_read,
                };
              } else {
                return {
                  ...l,
                };
              }
            });
          }
          const notificationsAll = {
            ..._request?.notificationsAll,
            notifications: getAllNotiOfAll,
          };

          dispatch(
            updateUserNotificationList({
              ..._request,
              notificationsUnRead: notificationsUnRead,
              notificationsRead: notificationsRead,
              notificationsAll: notificationsAll,
            })
          );
        }
      }

      if (notificationType === "all") {
        let index = _request?.notificationsAll?.notifications?.findIndex(
          (item: any) =>
            item.sk == _request?.update?.update[0]?.sk &&
            item.pk == _request?.update?.update[0]?.pk
        );

        if (index == 0 || index > 0) {
          let getAllNoti = _request?.notificationsAll?.notifications;
          const getNoti = {
            ...getAllNoti[index],
            is_read: _request?.update?.update[0]?.is_read,
          };

          let getAllNotiAll = getAllNoti.map((l: any, idx: any) => {
            if (idx == index) {
              return {
                ...l,
                is_read: _request?.update?.update[0]?.is_read,
              };
            } else {
              return {
                ...l,
              };
            }
          });

          const notificationsAll = {
            ..._request?.notificationsAll,
            notifications: getAllNotiAll,
          };

          let notificationsRead = {};
          let notificationsUnRead = {};
          const status = _request?.update?.update[0]?.is_read;
          if (status === true) {
            notificationsRead = {
              ..._request?.notificationsRead,
              notifications: [
                getNoti,
                ..._request?.notificationsRead?.notifications,
              ],
            };

            let URindex =
              _request?.notificationsUnRead?.notifications?.findIndex(
                (item: any) =>
                  item.sk == _request?.update?.update[0]?.sk &&
                  item.pk == _request?.update?.update[0]?.pk
              );

            const notificationsUnReadFilter =
              _request?.notificationsUnRead?.notifications?.filter(
                (l: any, i: any) => i != URindex
              );

            notificationsUnRead = {
              ..._request?.notificationsUnRead,
              notifications: notificationsUnReadFilter,
            };
          } else {
            notificationsUnRead = {
              ..._request?.notificationsUnRead,
              notifications: [
                getNoti,
                ..._request?.notificationsUnRead?.notifications,
              ],
            };

            let Rindex = _request?.notificationsRead?.notifications?.findIndex(
              (item: any) =>
                item.sk == _request?.update?.update[0]?.sk &&
                item.pk == _request?.update?.update[0]?.pk
            );

            const notificationsReadFilter =
              _request?.notificationsRead?.notifications?.filter(
                (l: any, i: any) => i != Rindex
              );

            notificationsRead = {
              ..._request?.notificationsRead,
              notifications: notificationsReadFilter,
            };
          }

          dispatch(
            updateUserNotificationList({
              ..._request,
              notificationsUnRead: notificationsUnRead,
              notificationsRead: notificationsRead,
              notificationsAll: notificationsAll,
            })
          );
        }
      }
    } catch (error) {}
  }
);

//Mark all as read
export const updateAllNotificationStatusThunk = createAsyncThunk(
  "updateAll/userNotification",
  async (_request: any, { dispatch }) => {
    try {
      const updateResponse = (await API.graphql(
        graphqlOperation(updateAllNotificationStatusMutation, {
          userName: _request.userName,
          isStatus: _request.isStatus,
        })
      )) as { data: any; errors: any[] };

      let {
        notificationsAll,
        notificationsRead,
        notificationsUnRead,
        count,
        read,
        unread,
      } = _request.list;

      //Unread Notifications
      const URnotifications = notificationsUnRead?.notifications;
      const notificationURData = {
        ...notificationsUnRead,
        notifications: [],
      };

      //Read Notifications
      const URnotificationsConvertRead = URnotifications.map((l: any) => {
        return {
          ...l,
          is_read: true,
        };
      });
      const notificationsRData = {
        ...notificationsRead,
        notifications: [
          ...URnotificationsConvertRead,
          ...notificationsRead?.notifications,
        ],
      };

      //All Notifications
      const Allnotifications = notificationsAll?.notifications;
      const AllnotificationsConvertRead = Allnotifications.map((l: any) => {
        return {
          ...l,
          is_read: true,
        };
      });
      const notificationsAllData = {
        ...notificationsAll,
        notifications: AllnotificationsConvertRead,
      };

      const newRead = read + unread; //read
      const newUnread = 0; //unread
      const newCount = count; //count

      //Update State
      dispatch(
        updateUserNotificationList({
          ..._request,
          notificationsUnRead: notificationURData,
          notificationsRead: notificationsRData,
          notificationsAll: notificationsAllData,
          read: newRead,
          unread: newUnread,
          count: newCount,
        })
      );
    } catch (error) {}
  }
);
